import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2, 0, 4),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1),
      marginBottom: '60px',
    },
  },
  tabContent: {
    maxWidth: 832,
    margin: '0 auto',
    width: '100%',
    boxSizing: 'border-box',
    padding: theme.spacing(2, 3, 0),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1.5, 2, 0),
    },
  },
  emptyStateContent: {
    padding: theme.spacing(4, 2),
  },
  groupEventsWrapper: {
    marginTop: 0,
    [theme.breakpoints.down('xs')]: {
      marginBottom: theme.spacing(8),
    },
  },
  tipBannerWrapper: {
    maxWidth: 832,
    margin: theme.spacing(0, 'auto', 3),
    width: '100%',
    boxSizing: 'border-box',
    padding: theme.spacing(2, 3, 0),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1.5, 2, 0),
      marginBottom: theme.spacing(2.5),
    },
  },
  tipBanner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    padding: theme.spacing(1.5, 2),
    borderRadius: 12,
    backgroundColor: '#E0EAFF',
    border: '1px solid #C5D4FF',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  tipBannerCopy: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    minWidth: 0,
    flex: '1 1 auto',
  },
  tipBannerIcon: {
    color: '#0053FF',
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  tipBannerText: {
    fontSize: '0.875rem',
    lineHeight: 1.4,
    color: '#172024',
    margin: 0,
  },
  tipBannerButton: {
    borderRadius: 20,
    textTransform: 'none',
    fontWeight: 700,
    fontSize: '0.9375rem',
    padding: theme.spacing(1, 2.5),
    whiteSpace: 'nowrap',
    flexShrink: 0,
    boxShadow: 'none',
    '&:hover': {
      boxShadow: '0 4px 12px rgba(0, 83, 255, 0.28)',
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  disabledActionTile: {
    backgroundColor: theme.palette.grey[200],
  },
}))
